import styles from './TravelDefaultSlider.module.scss'
import TravelInfoTeaser from '@/components/models/travel/teasers/TravelInfoTeaser'
import SliderWithDots from '@/components/elements/sliders/SliderWithDots'

interface TravelDefaultSliderProps {
  travels: Array<any>
  sliderOptions?: any
  dotOptions?: any
}

const TravelDefaultSlider = ({ travels, sliderOptions = {} }: TravelDefaultSliderProps) => {
  const sliderDefaultOptions = { loop: true, skipSnaps: true, containScroll: 'trimSnaps' }
  sliderOptions = { ...sliderDefaultOptions, ...sliderOptions }

  const getSlides = (travels: Array<any>) => {
    let slides: Array<any> = []
    travels.map((travel: any, index: number) => {
      const slide = (
        <div className={styles.slideWrap} key={index}>
          <div className={styles.slideInner}>
            <TravelInfoTeaser travel={travel} trackingStringPrefix={'travel_page:bestseller_slider'} />
          </div>
        </div>
      )
      slides.push(slide)
    })
    return slides
  }

  return (
    <>
      <SliderWithDots slides={getSlides(travels)} options={sliderOptions} autoplay={4000} trackingStringPrefix={'travel_page:bestseller_slider'} />
    </>
  )
}

export default TravelDefaultSlider
